import type { UserResource } from "@exonn/js-sdk";
import type { StorageKey } from "@exonn/storage";
import { memoryStorageDriver } from "src/storage/memoryStorage.driver.ts";
import { localStorageDriver } from "src/storage/localeStorage.driver.ts";
import { getUserDataStorageKey } from "src/user-data/cache/getUserDataStorageKey.ts";

export const setUserDataCache = <V = any>({
  user,
  key,
  value,
}: {
  user: UserResource;
  key: StorageKey;
  value: V | null;
}) => {
  const key_ = getUserDataStorageKey({
    user,
    key,
  });

  if (value == null && memoryStorageDriver.get<V>(key) != null) {
    memoryStorageDriver.remove(key_);
    localStorageDriver.remove(key_);
    return null;
  }
  localStorageDriver.set(key_, value);
  memoryStorageDriver.set(key_, value);
};
